<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h4>Реестры</h4>
            </v-flex>
            <v-flex xs12>
                <v-toolbar color="white" flat>
                    <v-text-field
                            class="mr-2"
                            label="Дата создания"
                            type="date"
                            v-model="tableSearch.period"
                    ></v-text-field>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    label="Фильтр"
                                    v-model.trim="tableSearch.search"
                                    v-on="on"
                            ></v-text-field>
                        </template>
                        <div>
                            <h4>Фильтрация производится по полям:</h4>
                            <ul>
                                <li>Поле "Код" - точное совпадение.</li>
                                <li>Поле "ОГРН" - точное совпадение.</li>
                                <li>Поле "Имя файл" - частичное совпадение без учета регистра.</li>
                            </ul>
                        </div>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-icon
                            @click="initialize()"
                            large
                    >
                        mdi-magnify
                    </v-icon>
                </v-toolbar>
            </v-flex>
            <v-flex md12 sm12 xs12>
                <v-data-table
                        :headers="headers"
                        :items="childrenGardenFiles.results"
                        :loading="listLoading.includes('kindergarten-fetchChildrenGardenFiles')"
                        :server-items-length="childrenGardenFiles.last_page"
                        class="elevation-1"
                        hide-default-footer
                        no-results-text="Нет отфильтрованных данных">
                    <template v-slot:header.action="{ header }">
                        <v-tooltip
                                bottom
                                open-delay="500" v-if="isWorker"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        :to="{name: 'kindergarten_registry', params: {'registry_id': 'new'}}"
                                        class="mr-2"
                                        icon
                                        v-on="on"
                                >
                                    <v-icon>mdi-pencil-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Добавить реестр</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:item.create_date="{ item }">
                        {{item.create_date|date_time}}
                    </template>
<!--                    <template v-slot:item.status="{ item }">-->
<!--                        {{ getStatus(item.status) }}-->
<!--                    </template>-->
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom open-delay="500">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        :to="{name: 'kindergarten_registry', params: {'registry_id': item.id}}"
                                        class="mr-2"
                                        icon
                                        v-on="on"
                                ><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                            <span>Редактировать</span>
                        </v-tooltip>
                    </template>
                    <template slot="no-data">
                        <v-btn @click="initialize" color="primary">Перегрузить</v-btn>
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            :length="childrenGardenFiles.last_page"
                            key="pagination"
                            v-model="pagination.page"
                    ></v-pagination>
                </div>
            </v-flex>
            <router-view></router-view>
        </v-layout>
    </v-container>
</template>

<script>

export default {
  data () {
    return {
      headers: [
        {
          text: 'Код',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Дата создания',
          align: 'start',
          sortable: false,
          value: 'create_date'
        },
        {
          text: 'Имя файл',
          align: 'start',
          sortable: false,
          value: 'filename'
        },
        {
          text: 'Статус обработки реестра',
          align: 'start',
          sortable: false,
          value: 'process_status.name'
        },
        {
          text: 'ОГРН',
          align: 'start',
          sortable: false,
          value: 'ogrn'
        },
        {
          text: 'Действие',
          align: 'start',
          sortable: false,
          value: 'action'
        }
      ],
      menuFilter: false,
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    childrenGardenFiles () {
      return this.$store.getters['kindergartenRegistries/childrenGardenFiles']
    },
    tableSearch () {
      return this.$store.getters['kindergartenRegistries/tableSearch']
    },
    user () {
      return this.$store.getters['auth/user']
    },
    isManager () {
      return this.user.groups.includes('Oktapod - Детсад - Реестры - Менеджеры')
    },
    isWorker () {
      return this.user.groups.includes('Oktapod - Детсад - Реестры')
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize () {
      this.$store.dispatch('kindergartenRegistries/fetchChildrenGardenFiles', {
        pageId: this.pagination.page
        // report_search: this.report_search
      })
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .custom-tooltip {
      opacity: 1!important;
  }
  .info1 {
      font-style: italic;
  }

</style>
